// extracted by mini-css-extract-plugin
export default {"facetPaletteList":"w51hY"};